import { createFileRoute } from '@tanstack/react-router'
import { BarChart3 } from 'lucide-react'

import { LotStatsPage } from '@/components/warehouse/lot-stats-page'
import { m } from '@/lib/paraglide/messages'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/agricultural-materials/stats',
)({
    component: () => (
        <LotStatsPage
            kind="agri_materials"
            title={m.nav_agri_stats()}
            subtitle={m.lot_stats_subtitle()}
            permission="agri_material_lots.read"
            icon={BarChart3}
            groupDimLabel={m.lot_stats_dim_material()}
            showUsageTab
        />
    ),
})
